import { HashRouter as Router, useLocation } from 'react-router-dom';
import { NavigationProvider } from './contexts/navigation';
import { getCurrentUser } from './api/auth';
import { useScreenSizeClass } from './utils/media-query';
import { Content } from './Content';
import { LoginPage } from './pages/login/LoginPage';
import React, { useEffect } from 'react';

import './theme/theme';
import '../src/styles.scss';

import { useThemeContext, ThemeContext } from './theme/theme';

import config from 'devextreme/core/config';
import { licenseKey } from './devextreme-key';

import { useTranslation, initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import tr from './i18n/tr.json';
import en from './i18n/en.json';
import de from './i18n/de.json';
import nl from './i18n/nl.json';
import fr from './i18n/fr.json';
import it from './i18n/it.json';
import dk from './i18n/dk.json';
import sa from './i18n/sa.json';
import ir from './i18n/ir.json';
import { getLanguageFromCookie } from './api/cookies';


import { routes } from './app-routes';
import { getAppToken } from './api/session';
import ThemeSettingsFromApi from './theme/grid-style';

config({ licenseKey });

function RootApp() {
  const user = getCurrentUser();
  const loading = false;
  const location = useLocation();

   var token = getAppToken();
  if (token!="" && token!="undefined" && token!=null) {
    return <><Content /><ThemeSettingsFromApi/></>;}
  
    
  useEffect(() => {
    const currentRoute = routes.find(route => route.path === location.pathname);
    if (currentRoute) {
      const title = typeof currentRoute.title === 'function'
        ? currentRoute.title()
        : currentRoute.title;
      document.title = `mobiSupport - ${title}`;
    } else {
      document.title = 'mobiSupport';
    }
  }, [location.pathname]);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Yükleniyor...</div>;
  }

  if (!user) {
    return <LoginPage />;
  }

  return <Content />;
}

// Dil ayarları
i18n
  .use(initReactI18next) // react-i18next'i başlatın
  .init({
    resources: {
      en: { translation: en },
      tr: { translation: tr },
      de: { translation: de },
      nl: { translation: nl },
      fr: { translation: fr },
      it: { translation: it },
      dk: { translation: dk },
      sa: { translation: sa },
      ir: { translation: ir },
    },
    lng: getLanguageFromCookie(), // varsayılan dil
    fallbackLng: 'en', // varsayılan dil
    interpolation: {
      escapeValue: false
    }
  });

export const App = () => {
  const screenSizeClass = useScreenSizeClass();
  const themeContext = useThemeContext();

  return (
    <Router>

      <ThemeContext.Provider value={themeContext}>
        <NavigationProvider>
          <div className={`app ${screenSizeClass}`}>
            {
              themeContext.isLoaded ? <RootApp /> : ''
            }
          </div>
        </NavigationProvider>
      </ThemeContext.Provider>
    </Router>
  );
};
